module.exports = __webpack_public_path__ + "static/media/me.294265da.png";